module.exports = __webpack_public_path__ + "img/governincn1.caa109ff.svg";